// src/App.tsx

import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Header from "./components/Header.tsx";
import Company from "./pages/Company.tsx";
import Marketing from "./pages/Marketing.tsx";
import ITSolutions from "./pages/ITsolutions.tsx";
import Portfolio from "./pages/Portfolio.tsx";
import styled from "styled-components";
import Footer from "./components/Footer.tsx";

const Wrapper = styled.div`
  width: auto;
  display: flex;
  justify-content: center;
  background-color: #0f0f0f;
`;

const Container = styled.div`
  width: auto;
  height: auto;
  overflow-x: hidden;
  overflow-y: auto;
  background-color: #0f0f0f;
  display: flex;
  flex-direction: column;

  @media (max-width: 375px) {
    width: 100%;
  }
`;

function App() {
  return (
    <Router>
      <Container>
        <Header />
        <Routes>
          <Route path="/" element={<Company />} />
          <Route path="/marketing" element={<Marketing />} />
          <Route path="/itsolutions" element={<ITSolutions />} />
          <Route path="/portfolio" element={<Portfolio />} />
        </Routes>
        <Footer />
      </Container>
    </Router>
  );
}

export default App;
